const colorToClassMap = {
  error: 'c-badge--error',
  info: 'c-badge--info',
  primary: 'c-badge--primary',
  success: 'c-badge--success',
  warning: 'c-badge--warning',
};

export const BADGE_COLORS = Object.keys(colorToClassMap);
export const BADGE_CLASS_MAP = { color: colorToClassMap };
